
 

 

 

 
class ACLTemplateUpdateParameter 
{
    
        UserUID: string;
    
        Items: any;
    
}
 
export default ACLTemplateUpdateParameter;
 

